import { useNavigate } from 'react-router-dom';

// import Button from '@/components/Button';
import Container from '@/components/Container';
import DefaultContentTemplate from '@/components/DefaultContentTemplate';
// import { CheckIcon } from '@heroicons/react/24/solid';

import { completeTask } from '@/services/daily/complete-tasks.service';

import {
  Enum_Completedtask_Type,
  Enum_Favorite_Type,
  FetchUserStreakQuery,
  FetchUserStreakQueryVariables,
  InsightPage,
  ResourceEntity,
} from '@/graphql/generated/graphql';

import './style.css';
import { useEffect, useLayoutEffect, useState } from 'react';
import Divider from '@/components/Divider';
import PageHeader from '@/components/PageHeader';
import { renderCards } from '../knowledge-hub/main';
import { fetchLatestResourcesByTopic } from '@/services/knowledge-hub/knowledge-hub.service';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import TitleWithActions from '@/components/TitleWithActions';
import { useHomeStore } from '../home/useHome';
import { getPage } from '@/services/daily/daily-insight.service';
import Button from '@/components/Button';
import { useResponsiveImage } from '@/utils/useResponsiveImage';
import { QUERY_FETCH_USER_STREAK } from '@/graphql/queries/daily/completed-tasks';
import { useQuery } from '@apollo/client';
import StatsAndStreak, { StatsAndStreakContainer } from '@/components/StatsAndStreak';
import { clearDailyInsightDataLayer, trackDailyInsight } from '@/lib/ga-custom-events/dailyInsight';

const DailyInsightPage = () => {
  const { dailyInsight, dailyInsightCompleted, handleDailyInsight, page: homePage, fetchHomePage } = useHomeStore();
  const [youMayAlso, setYouMayAlso] = useState<ResourceEntity[]>([]);
  const [page, setPage] = useState<InsightPage | null>(null);
  const [completedNow, setCompletedNow] = useState<boolean>(false);

  const { data: insightData, refetch } = useQuery<FetchUserStreakQuery, FetchUserStreakQueryVariables>(
    QUERY_FETCH_USER_STREAK,
    {
      variables: {
        type: 'INSIGHT',
      },
    },
  );

  const navigate = useNavigate();
  const { insight } = dailyInsight || {};

  const { src } = useResponsiveImage(insight?.attributes?.cover || { url: '', alternativeText: '' });

  const resource = insight?.attributes?.resource?.data?.attributes || null;

  useLayoutEffect(() => {
    if (!insight?.id) {
      return;
    }

    async function getYouMayAlso() {
      const page = await getPage();

      setPage(page?.page);
      const latests = await fetchLatestResourcesByTopic(
        insight!.attributes?.themes?.data[0]?.attributes?.topic?.data?.attributes?.topic || '',
        2,
        insight!.id,
      );

      if (latests.resorces === null) {
        return;
      }

      if (latests.resorces!.length! > 0) {
        setYouMayAlso(latests.resorces as ResourceEntity[]);
      }
    }

    getYouMayAlso();
  }, [dailyInsightCompleted, navigate, insight]);

  useEffect(() => {
    if (completedNow) {
      refetch();
    }
  }, [completedNow, refetch]);

  useEffect(() => {
    fetchHomePage();
  }, [fetchHomePage]);

  useEffect(() => {
    if (!insight || dailyInsightCompleted) {
      return;
    }
    async function completeDailyInsight() {
      await completeTask({
        entity: insight,
        type: Enum_Completedtask_Type.Insight,
      });
    }

    setCompletedNow(true);
    completeDailyInsight();

    trackDailyInsight({
      insightId: insight?.id || '',
      insightTitle: insight?.attributes?.title || '',
    });
  }, [insight, dailyInsightCompleted, handleDailyInsight]);

  useEffect(() => {
    handleDailyInsight();

    return () => {
      clearDailyInsightDataLayer();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contentTemplate = insight?.attributes?.DefaultContentTemplate?.filter(
    (c) => (c?.__typename as string) !== 'ComponentCommonAuthor' && (c?.__typename as string) !== 'ComponentCommonTags',
  );
  const contentAuthor = insight?.attributes?.DefaultContentTemplate?.find(
    (c) => c?.__typename === 'ComponentCommonAuthor',
  );

  return (
    <>
      <Container className="mt-sh-60">
        <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
          <PageHeader title="Daily Insight" url="/" type="insight" />
        </div>
        <div className="col-span-12 aspect-video gap-4 overflow-hidden rounded-2xl lg:col-start-3 lg:col-end-11">
          <img
            src={src}
            alt={insight?.attributes?.cover?.data?.attributes?.alternativeText || ''}
            className="h-full w-full object-cover object-center"
          />
        </div>
        <div className="col-span-12 mt-4 aspect-video gap-4 lg:col-start-3 lg:col-end-11">
          {insight?.attributes?.duration !== null ? (
            <DefaultContentTemplateTags
              tags={[insight?.attributes?.type || '']}
              className="!mb-sh-15 !mt-0"
              duration={insight?.attributes?.duration || undefined}
            />
          ) : null}

          <div>
            {insight?.id ? (
              <TitleWithActions
                title={insight?.attributes?.title || ''}
                favorite={false}
                entity={insight}
                type={Enum_Favorite_Type.Insight}
                entityId={insight!.id}
              />
            ) : null}

            <p className="my-sh-15 text-sh-18-24">{insight?.attributes?.subHeader}</p>

            {contentAuthor ? <DefaultContentTemplate fitContent content={[contentAuthor]} /> : null}

            {contentTemplate ? (
              <DefaultContentTemplate fitContent content={contentTemplate} idBodyDivider={false} />
            ) : null}

            {insight && !resource && <Divider />}

            {/* {!insight ? null : (
              <div>
                <Button
                  onClick={async () => {
                    const { error } = await completeTask({
                      entity: insight,
                      type: Enum_Completedtask_Type.Insight,
                    });

                    if (error) {
                      return;
                    }

                    navigate('/');
                  }}
                  disabled={dailyInsightCompleted}
                  theme={'solid'}
                  className="flex items-center justify-center">
                  <CheckIcon className="mr-2 inline-block h-4 w-4" />
                  Mark as done
                </Button>
              </div>
            )} */}

            {completedNow || dailyInsightCompleted ? (
              <StatsAndStreakContainer className="mt-sh-60">
                <StatsAndStreak
                  type="INSIGHT"
                  value={insightData?.fetchUserStreak?.total || 0}
                  unit={homePage?.finishingCard?.finishingCardInsight?.insights || 'Insights'}
                  title={homePage?.finishingCard?.finishingCardInsight?.youHaveRead || "You've read"}
                  color="INSIGHT"
                />
                <StatsAndStreak
                  type="STREAK"
                  value={insightData?.fetchUserStreak?.streak || 0}
                  unit={homePage?.finishingCard?.finishingCardInsight?.days || 'Days'}
                  title={homePage?.finishingCard?.finishingCardInsight?.yourStreak || 'Your streak'}
                  color="INSIGHT"
                />
              </StatsAndStreakContainer>
            ) : null}

            {resource && (
              <div className="mt-sh-60 flex justify-center">
                <Button
                  theme={'solid'}
                  className="flex max-w-fit items-center"
                  as="a"
                  href={`/knowledge-hub/slug/${resource?.slug}`}>
                  Continue reading
                </Button>
              </div>
            )}

            <div className={youMayAlso.length > 0 ? 'mt-sh-30' : ''}>
              {renderCards({
                title: page?.relatedContentTitle || 'You may also like',
                data: youMayAlso,
                showDivider: false,
                viewAll: true,
                viewAllText: page?.relatedContentViewAllLabel || 'View All',
              })}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default DailyInsightPage;
